export default function useFontSize() {
  // these inputs are calculated from an excel chart and there is a confluence on it (text input, beginScale (length of text at which to begin scaling), maxFontSize, scale, factor)
  // maxFontSize was used when we made shorter text longer. Although we're not using it now, let's keep it in case we need it for the excel chart
  function calculateFontSize(text, beginScale, maxFontSize, scale, factor) {
    const singleLongWordCondition =
      text.split(/\s+/).length === 1 && text.length > 11;

    // If it's a single long word, treat it as slightly longer; otherwise, use text.length
    const effectiveLength = singleLongWordCondition
      ? text.length * 2.2
      : text.length;

    if (text.length > beginScale || singleLongWordCondition) {
      const newFontSize = scale * Number(effectiveLength) ** factor;
      const newLineHeight = newFontSize + 0.3;
      const fontSize = `${newFontSize.toFixed(2)}vw`;
      const lineHeight = `${newLineHeight.toFixed(2)}vw`;
      return { "font-size": fontSize, "line-height": lineHeight };
    }

    return {};
  }

  return {
    calculateFontSize,
  };
}
